import React from 'react'

export const RightArrow = () => (
  <svg
    width="11px"
    height="10px"
    viewBox="0 0 11 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Artboard"
        transform="translate(-488.000000, -570.000000)"
        fill="#FFFFFF"
      >
        <g id="Group-35" transform="translate(148.000000, 488.000000)">
          <path
            d="M347.960065,87.928288 L340.865339,87.928288 C339.711554,87.928288 339.711554,86.1154161 340.865339,86.1154161 L347.960065,86.1154161 L345.438411,83.551054 C344.62618,82.7551427 345.865764,81.428745 346.677983,82.2686457 L350.695362,86.3365562 C351.079811,86.6903464 351.122715,87.3091411 350.695362,87.7072615 L346.677983,91.7311943 C345.865753,92.5714927 344.626565,91.2446857 345.438411,90.4487857 L347.960065,87.928288 Z"
            id="Fill-1"
          />
        </g>
      </g>
    </g>
  </svg>
)
